export class createCheckIn {
  public actualDate: string;
  public actualTime: string;
  public vehicleNo: string;
  public driverName: string;
  public tracking: string;
  public door: string;
  constructor() {
    this.actualDate = "";
    this.actualTime = "";
    this.vehicleNo = "";
    this.driverName = "";
    this.tracking = "";
    this.door = "";
  }
}

export class asnAdvanceFilter {
  public supplier: string;
  constructor() {
    this.supplier = "";
  }
}